import type { ReactNode } from "react";
import { Card } from "antd";

export function SectionCard({ children }: { children: ReactNode }) {
  return (
    <Card
      styles={{
        body: {
          display: "flex",
          flexDirection: "column",
          gap: 8,
        },
        root: {
          borderColor: "var(--line)",
        },
      }}
    >
      {children}
    </Card>
  );
}
